<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import BackToTop from 'vue-backtotop';
import Menu from './components/Menu';
import Footer from './components/Footer';

export default {
  name: 'App',
  data() {
    return {
    };
  },
  components: {
    Menu,
    Footer,
    BackToTop,
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Noto+Serif|Noto+Serif+TC|ZCOOL+QingKe+HuangYou|ZCOOL+XiaoWei');

body {
  margin: 0px;
  font-size: 22px;
  @media (max-width: 768px) {
    font-size: 15px;
  }
}

@font-face {
  font-family: 'Custom Noto Serif TC TW';
  font-style: normal;
  font-weight: 400;
  src: local('Noto Serif TC'), local('NotoSerifTC-Regular'), url(https://fonts.gstatic.com/s/notoseriftc/v2/XLYgIZb5bJNDGYxLBibeHZ0BhnIET3FsCN0FAgvgEq4qZwtrwBrhpwcyws-Z2oxkXLqzDtbj3psk.5.woff2) format('woff2');
  unicode-range: U+4E00-9FFF;
}

#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-family: 'Noto Serif TC', Helvetica, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
  min-height: 100vh;
}

.singleContent {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 5px 10px;
  span:hover {
    cursor: pointer;
    background-color: rgba(209, 200, 199, 0.24);
  }

  .highlight {
    background-color: rgba(230, 124, 47, 0.4);
  }

  .highlight:hover {
    background-color: rgba(230, 124, 47, 0.4);
  }

}

#article {
  .singleContent {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding: 5px 10px;
    span:hover {
      cursor: pointer;
      background-color: transparent;
      text-decoration: underline;
    }

    .highlight {
      background-color: transparent;
    }

    .highlight:hover {
      background-color: none;
    }

  }
}

p {
  white-space: pre-line;
}

</style>



// WEBPACK FOOTER //
// src/App.vue